export default __webpack_public_path__ + "7cad5f18a85d15399af143aa8e6046ec.svg";